module.exports = __webpack_public_path__ + "img/20.01d1dfb2.jpg";